
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class TaxRateDialog extends Serenity.EntityDialog<TaxRateRow, any> {
        protected getFormKey() { return TaxRateForm.formKey; }
        protected getIdProperty() { return TaxRateRow.idProperty; }
        protected getLocalTextPrefix() { return TaxRateRow.localTextPrefix; }
        protected getService() { return TaxRateService.baseUrl; }
        protected getDeletePermission() { return TaxRateRow.deletePermission; }
        protected getInsertPermission() { return TaxRateRow.insertPermission; }
        protected getUpdatePermission() { return TaxRateRow.updatePermission; }

        protected form = new TaxRateForm(this.idPrefix);

    }
}